module.exports = __webpack_public_path__ + "img/home4.fbb82984.png";